import React, { useState, useEffect } from 'react';
import './PerdoorTempleHistory.css';

const PerdoorTempleHistory = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const carouselImages = [
    {
      url: "https://perdoorshriananthapadmanabhatemple.org/assets/theme/images/events/thumbs/6.JPG",
      caption: "ಪೆರ್ಡೂರು ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭ ಸ್ವಾಮಿ ದೇವಾಲಯ - Temple Events"
    },
    {
      url: "https://perdoorshriananthapadmanabhatemple.org/assets/theme/images/events/thumbs/5.JPG",
      caption: "ದೇವಾಲಯದ ವಿಷೇಶ ಸಮಾರೋಹ - Special Temple Ceremonies"
    },
    {
      url: "https://perdoorshriananthapadmanabhatemple.org/assets/theme/images/events/thumbs/8.JPG",
      caption: "ರಥೋತ್ಸವ ಆಚರಣೆ - Rathotsava Celebrations"
    },
    {
      url: "https://perdoorshriananthapadmanabhatemple.org/assets/theme/images/events/thumbs/9.jpg",
      caption: "ಭಕ್ತರ ಭಾಗವಹಿಸುವಿಕೆ - Devotee Participation"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const nextImage = () => {
    setCurrentImageIndex(currentImageIndex === carouselImages.length - 1 ? 0 : currentImageIndex + 1);
  };

  const prevImage = () => {
    setCurrentImageIndex(currentImageIndex === 0 ? carouselImages.length - 1 : currentImageIndex - 1);
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="temple-page">
      <div className="temple-container">
        <div className="hero-section" style={{ backgroundImage: 'url(https://perdoorshriananthapadmanabhatemple.org/assets/theme/images/festivals/fest7.jpg)' }}>
          <div className="hero-overlay">
            <h1 className="hero-title"> ಪೆರ್ಡೂರು ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭ ಸ್ವಾಮಿ ದೇವಾಲಯ</h1>
            <p className="hero-subtitle">Perdoor Sri Ananthapadmanabha Swamy Temple</p>
          </div>
        </div>

        <div className="content">
          <section className="section">
            <h2 className="section-title">🌿ಪೆರ್ಡೂರು ದೇವಾಲಯದ ಪರಿಚಯ - Temple Overview</h2>
            <p className="text-kan">
              ಪೆರ್ಡೂರು ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭ ಸ್ವಾಮಿ ದೇವಾಲಯವು ಕರ್ನಾಟಕದ ಉಡುಪಿ ಜಿಲ್ಲೆಯಲ್ಲಿ ನೆಲೆಸಿದ್ದು, ಉಡುಪಿಯಿಂದ 20 ಕಿಲೋಮೀಟರ್ ಮತ್ತು ಹೆಬ್ರಿಯಿಂದ 14 ಕಿಲೋಮೀಟರ್ ದೂರದಲ್ಲಿದೆ. ಈ ಪ್ರಾಚೀನ ದೇವಾಲಯವು 6-7ನೇ ಶತಮಾನದಲ್ಲಿ ನಿರ್ಮಿಸಲಾಗಿದ್ದು, ಸುಮಾರು 800 ವರ್ಷಗಳ ಇತಿಹಾಸವನ್ನು ಹೊಂದಿದೆ.
            </p>
            
            <p className="text-en">
              The temple houses a magnificent 2-feet tall idol of Lord Ananthapadmanabha Swamy in standing posture, adorned with Shankha (conch), Chakra (discus), and Abhaya Hasta (blessing gesture). The deity is also known as Kadalipriya Anantha Padmanabha Swamy, reflecting the special connection with banana offerings.
            </p>
            
            <div className="highlight-box">
              "ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭ ಸ್ವಾಮಿ ದೇವರ ವಿಗ್ರಹವು ಶಂಖ, ಚಕ್ರ ಮತ್ತು ಅಭಯ ಹಸ್ತವನ್ನು ಹೊಂದಿದ್ದು, ಅದ್ಭುತ ಶಿಲ್ಪಕಲೆಯಿಂದ ಕೂಡಿದೆ."
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">📜 ಐತಿಹಾಸಿಕ ಹಿನ್ನೆಲೆ - Historical Background</h2>
            <p className="text-kan">
              ಸ್ಥಳ ಪುರಾಣದ ಪ್ರಕಾರ, ಈ ದೇವಾಲಯವನ್ನು ಕೋಟಿಕುಂಜದ ರಾಜ ಶಂಕರನ ಕಾಲದಲ್ಲಿ ಕೃಷ್ಣ ಶರ್ಮಾ ಎಂಬ ಬ್ರಾಹ್ಮಣನು ಸ್ಥಾಪಿಸಿದ್ದನು. ಶ್ರೀ ಕೃಷ್ಣ ಹೆಬ್ಬಾರ್ ಎಂಬವರು 1754 ರಿಂದ 1821 ರವರೆಗೆ ಈ ದೇವಾಲಯವನ್ನು ಪುನಃ ನಿರ್ಮಿಸಿದರು.
            </p>
            
            <p className="text-en">
              The temple's significance grew when Raja Vijayappa Odeyar donated the entire Banampalli village as an Umbali (gift) for the temple's maintenance and upkeep. This royal patronage established the temple as a major pilgrimage center in the region.
            </p>
            <div className="info-box">
              <strong>Ancient Inscriptions:</strong><br/>
              • 1458 CE: Deity referred to as "Janardhana Deva" and later as "Ananta Deva"<br/>
              • 1520 CE: Clearly mentions "Sri Ananthapadmanabha Swamy"
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🎋 ಪೂಜಾ ಕ್ರಮ ಮತ್ತು ಸಂಪ್ರದಾಯಗಳು - Worship Rituals & Traditions</h2>
            <div className="grid">
              <div className="card">
                <div className="card-icon">🙏</div>
                <h3>ಸಾವಿರದೊಂದು ಸೇವೆ (Banana Seva)</h3>
                <p className="text-kan">
                  ಭಕ್ತರು ತಮ್ಮ ಇಚ್ಛೆಗಳು ಪೂರ್ಣಗೊಂಡ ಮೇಲೆ ದೇವರಿಗೆ 1001 ಬಾಳೆಹಣ್ಣುಗಳನ್ನು ಅರ್ಪಿಸುವ "ಸಾವಿರದೊಂದು ಸೇವೆ" ಅಥವಾ "ಹರಿಕೆ ಸೇವೆ" ಇತ್ತೀಚಿನ ವರ್ಷಗಳಲ್ಲಿ ಹೆಚ್ಚು ಪ್ರಸಿದ್ಧವಾಗಿದೆ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🕉️</div>
                <h3>ಗಣಪತಿ ಪೂಜೆ</h3>
                <p className="text-kan">
                  ಪೂಜೆಗಳಿಗೆ ಮೊದಲು ತೀರ್ಥ ಮಂಟಪದ ಗಣಪತಿಗೆ ಪೂಜೆ ಸಲ್ಲಿಸುವುದು ಆಚರಣೆಯಾಗಿದೆ. ಸ್ತಂಭದ ಮೇಲಿರುವ ಗಣಪತಿ ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯವಾಗಿದೆ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🥈</div>
                <h3>ಬೆಳ್ಳಿ ಅಂಗಾಂಗ ಮಾದರಿಗಳು</h3>
                <p className="text-kan">
                  ಹಲವರು ಬೆಳ್ಳಿಯ ಅಂಗಾಂಗ ಮಾದರಿಗಳನ್ನು (ಕೈ, ಕಾಲು, ಕಣ್ಣು ಮುಂತಾದವು) ಅರ್ಪಿಸುವ ಮೂಲಕ ತಮ್ಮ ಇಚ್ಛೆ ಪೂರೈಕೆಗಾಗಿ ಕೃತಜ್ಞತೆ ಸಲ್ಲಿಸುತ್ತಾರೆ.
                </p>
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🖼️ ದೇವಾಲಯ ಚಿತ್ರಗಳು - Temple Image Gallery</h2>
            <p className="text-en">
              Explore the divine beauty and architectural splendor of Perdoor Sri Ananthapadmanabha Temple through this collection of sacred images.
            </p>
            <div className="carousel">
              <img
                className="carousel-image"
                src={carouselImages[currentImageIndex].url}
                alt={carouselImages[currentImageIndex].caption}
              />
              <button className="carousel-nav left" onClick={prevImage}>❮</button>
              <button className="carousel-nav right" onClick={nextImage}>❯</button>
              <div className="carousel-dots">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => goToImage(index)}
                  />
                ))}
              </div>
              <div className="carousel-caption">
                {carouselImages[currentImageIndex].caption}
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🛕 ದೇವಾಲಯದ ವಿನ್ಯಾಸ ಮತ್ತು ವೈಶಿಷ್ಟ್ಯಗಳು - Temple Architecture & Features</h2>
            <div className="grid">
              <div className="card">
                <div className="card-icon">🏛️</div>
                <h3>ಮುಖ್ಯ ವಿಗ್ರಹ</h3>
                <p className="text-kan">
                  ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭಸ್ವಾಮಿ ದೇವರ 2 ಅಡಿ ಎತ್ತರದ ನಿಂತ ವಿಗ್ರಹವು ಶಂಖ, ಚಕ್ರ ಮತ್ತು ಅಭಯ ಹಸ್ತವನ್ನು ಹೊಂದಿದ್ದು, ಅದ್ಭುತ ಶಿಲ್ಪಕಲೆಯಿಂದ ಕೂಡಿದೆ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🏊</div>
                <h3>ಪಾದಕೋಣೆ (Pushkarani)</h3>
                <p className="text-kan">
                  ದೇವಾಲಯಕ್ಕೆ ಲಗತ್ತಿಸಲಾದ ಪದ್ಮ ಸರೋವರ (ಪುಷ್ಕರಿಣಿ) ಸುತ್ತಲೂ ಮೆಟ್ಟಿಲುಗಳಿರುವ ಪವಿತ್ರ ಜಲಾಶಯವಾಗಿದೆ. ಇದನ್ನು ಮಾಧ್ವಾಚಾರ್ಯರು ತಮ್ಮ ತಾಯಿಗಾಗಿ ನಿರ್ಮಿಸಿದ್ದಾರೆ ಎಂದು ನಂಬಲಾಗಿದೆ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🕉️</div>
                <h3>ಸಹದೇವತೆಗಳು</h3>
                <p className="text-kan">
                  ದೇವಾಲಯದ ಒಳಗೆ ರುದ್ರಲಿಂಗ, ರಥೋತ್ಸವ ಕಟ್ಟೆ, ಮತ್ತು ತೀರ್ಥ ಮಂದಿರದಲ್ಲಿರುವ ಸ್ತಂಭದ ಮೇಲಿರುವ ಗಣಪತಿ ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳಾಗಿವೆ.
                </p>
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🎊 ವಿಶೇಷ ಉತ್ಸವಗಳು - Special Festivals</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
                <div className="timeline-year">ರಥೋತ್ಸವ (Rathotsava)</div>
                <p className="text-kan">
                  ಕುಂಭ ಮಾಸದಲ್ಲಿ 5 ದಿನಗಳ ಕಾಲ ಉತ್ಸವ ನಡೆಯುತ್ತದೆ. ಭಕ್ತರು ದೇವಾಲಯದ ಸುತ್ತಲೂ ರಥವನ್ನು ಎಳೆಯುವ ಮೂಲಕ ಭಾಗವಹಿಸುತ್ತಾರೆ. ಈ ಸಮಯದಲ್ಲಿ "ಸಾವಿರಪ್ರಂಧ" ಎಂದೂ ಕರೆಯುವ ಬಾಳೆಹಣ್ಣು ಸೇವೆ ಇನ್ನೂ ವಿಶಿಷ್ಟವಾಗಿದೆ.
                </p>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
                <div className="timeline-year">ಸಂಕ್ರಮಣ ಪೂಜೆ</div>
                <p className="text-kan">
                  ಸಿಂಹ ಮತ್ತು ಮೀನಾ ಸಂಕ್ರಮಣದ ಸಂದರ್ಭದಲ್ಲಿ ವಿಶೇಷ ಆರಾಧನೆ ಮತ್ತು ಪವಿತ್ರತೆಯೊಂದಿಗೆ ಆಚರಣೆ ನಡೆಯುತ್ತದೆ. ಭಕ್ತರು ದೂರದೂರದಿಂದ ಬಂದು ಈ ಪೂಜೆಯಲ್ಲಿ ಭಾಗವಹಿಸುತ್ತಾರೆ.
                </p>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
                <div className="timeline-year">ಇತರ ಪ್ರಮುಖ ಉತ್ಸವಗಳು</div>
                <p className="text-kan">
                  ಮಾಸಿಕ ಏಕಾದಶಿ, ಅಮಾವಾಸ್ಯೆ, ಪೂರ್ಣಿಮೆ ಮತ್ತು ಸಂಕ್ರಮಣ ದಿನಗಳಲ್ಲಿ ವಿಶೇಷ ಪೂಜೆಗಳು ನಡೆಯುತ್ತವೆ. ಕೃಷ್ಣಾಷ್ಟಮಿ ಮತ್ತು ರಾಮನವಮಿಯಲ್ಲಿ ಭವ್ಯ ಆಚರಣೆಗಳು ನಡೆಯುತ್ತವೆ.
                </p>
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🕒 ದೇವಾಲಯದ ಸಮಯಗಳು - Temple Timings</h2>
            <div className="info-box">
              <strong>ದೈನಂದಿನ ಸಮಯಗಳು:</strong><br/>
              • ಪ್ರಾತಃಕಾಲ: 6:00 AM - 12:30 PM<br/>
              • ಸಾಯಂಕಾಲ: 4:00 PM - 8:30 PM<br/><br/>
              <strong>ಪ್ರಮುಖ ಪೂಜೆಗಳು:</strong><br/>
              • ಪ್ರಾತಃ ಪೂಜೆ: 7:00 AM<br/>
              • ಮಧ್ಯಾಹ್ನದ ಪೂಜೆ: 12:30 PM<br/>
              • ಸಂಜೆ ಪೂಜೆ: 7:30 PM
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🧭 ದೇವಾಲಯಕ್ಕೆ ಹೇಗೆ ತಲುಪುವುದು - How to Reach</h2>
            <div className="grid">
              <div className="card">
                <div className="card-icon">🚌</div>
                <h3>ಬಸ್ ಸೇವೆ</h3>
                <p className="text-kan">
                  ಉಡುಪಿ (20 ಕಿಮೀ) ಮತ್ತು ಮಂಗಳೂರು (60 ಕಿಮೀ) ಇಂದ ನಿಯಮಿತ ಬಸ್ ಸೇವೆ ಲಭ್ಯವಿದೆ. ಹೆಬ್ರಿಯಿಂದ 14 ಕಿಮೀ ದೂರದಲ್ಲಿದೆ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🚂</div>
                <h3>ರೈಲು ಸೇವೆ</h3>
                <p className="text-kan">
                  ಹತ್ತಿರದ ನಿಲ್ದಾಣ ಉಡುಪಿ (20 ಕಿಮೀ). ಮಂಗಳೂರು ಸೆಂಟ್ರಲ್ (60 ಕಿಮೀ) ಮತ್ತು ಮಂಗಳೂರು ಜಂಕ್ಷನ್ (65 ಕಿಮೀ) ಇಂದ ಟ್ಯಾಕ್ಸಿ ಸೇವೆ ಲಭ್ಯ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">✈️</div>
                <h3>ವಿಮಾನ ನಿಲ್ದಾಣ</h3>
                <p className="text-kan">
                  ಮಂಗಳೂರು ಅಂತರಾಷ್ಟ್ರೀಯ ವಿಮಾನ ನಿಲ್ದಾಣ (80 ಕಿಮೀ). ಬೆಂಗಳೂರು ಅಂತರಾಷ್ಟ್ರೀಯ ವಿಮಾನ ನಿಲ್ದಾಣ (400 ಕಿಮೀ).
                </p>
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">📚 ಶಿಕ್ಷಣ ಮತ್ತು ಗ್ರಾಮೀಣ ಅಭಿವೃದ್ಧಿ - Education & Development</h2>
            <div className="highlight-box">
              <strong>ಪ್ರಮುಖ ಶಿಕ್ಷಣ ಸಂಸ್ಥೆಗಳು:</strong><br/>
              • B.M ಪ್ರಾಥಮಿಕ ಶಾಲೆ (100+ ವರ್ಷಗಳ ಇತಿಹಾಸ)<br/>
              • ಪೆರ್ಡೂರು ಹೈಸ್ಕೂಲ್<br/>
              • ಇಂಡಸ್ಟ್ರಿಯಲ್ ಟ್ರೈನಿಂಗ್ ಇನ್ಸ್ಟಿಟ್ಯೂಟ್<br/>
              • ಆದರ್ಶ ಪದವಿಪೂರ್ವ ಕಾಲೇಜು (2011-12 ರಲ್ಲಿ ಸ್ಥಾಪಿತ)
            </div>
            <p className="text-en">
              ದೇವಾಲಯದ ಸುತ್ತಲಿನ ಕಾಡನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಿ ಈಗ ಸಂಪೂರ್ಣ ನಗರವನ್ನಾಗಿ ಪರಿವರ್ತಿಸಲಾಗಿದೆ. ಆಧುನಿಕ ಸೌಲಭ್ಯಗಳೊಂದಿಗೆ ಪ್ರಾಚೀನ ಸಂಸ್ಕೃತಿಯನ್ನು ಸಂರಕ್ಷಿಸುವ ಪ್ರಯತ್ನ ಮಾಡಲಾಗಿದೆ.
            </p>
          </section>

          <section className="section">
            <h2 className="section-title">🍽️ ಸ್ಥಳೀಯ ಆಹಾರ ಮತ್ತು ವಸತಿ - Local Food & Accommodation</h2>
            <div className="grid">
                           <div className="card">
                <div className="card-icon">🏨</div>
                <h3>ವಸತಿ ಸೌಲಭ್ಯಗಳು</h3>
                <p className="text-kan">
                  ದೇವಾಲಯದ ಸುತ್ತಲೂ ಗೆಸ್ಟ್ ಹೌಸ್‌ಗಳು ಮತ್ತು ಹೋಟೆಲ್‌ಗಳು ಲಭ್ಯವಿದೆ. ಮುಂಚಿತವಾಗಿ ಬುಕ್ಕಿಂಗ್ ಮಾಡಿಕೊಳ್ಳುವುದು ಉತ್ತಮ.
                </p>
              </div>
              <div className="card">
                <div className="card-icon">🛍️</div>
                <h3>ಸ್ಥಳೀಯ ಉತ್ಪಾದನೆಗಳು</h3>
                <p className="text-kan">
                  ಪ್ರಸಾದಮ್, ಪೂಜಾ ಸಾಮಗ್ರಿಗಳು, ಸ್ಥಳೀಯ ಕರಕುಶಲ ವಸ್ತುಗಳು ಮತ್ತು ಧಾರ್ಮಿಕ ಪುಸ್ತಕಗಳು ಲಭ್ಯವಿದೆ.
                </p>
              </div>
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🌐 ಸಂಪರ್ಕ ಮಾಹಿತಿ - Contact Information</h2>
            <div className="info-box">
              <strong>ಮುಖ್ಯ ಮಾಹಿತಿ:</strong><br/>
              • ವೆಬ್‌ಸೈಟ್: perdoorshriananthapadmanabhatemple.org<br/>
              • ಸ್ಥಳ: ಪೆರ್ಡೂರು, ಉಡುಪಿ ಜಿಲ್ಲೆ, ಕರ್ನಾಟಕ<br/>
              • ಪಿನ್ ಕೋಡ್: 576124<br/>
              • ಹತ್ತಿರದ ಪೋಸ್ಟ್ ಆಫೀಸ್: ಪೆರ್ಡೂರು<br/>
              • ಪೊಲೀಸ್ ಠಾಣೆ: ಹಿರಿಯಡ್ಕ<br/>
              • ಆಸ್ಪತ್ರೆ: ಸರ್ಕಾರಿ ಆಸ್ಪತ್ರೆ, ಕುಕ್ಕೆಹಳ್ಳಿ
            </div>
          </section>

          <section className="section">
            <h2 className="section-title">🔮 ಭಕ್ತರ ಅನುಭವಗಳು - Devotee Experiences</h2>
            <div className="highlight-box">
              <strong>ಪ್ರಮುಖ ಮಹತ್ವ:</strong><br/>
              • ಕದಳಿಪ್ರಿಯ ಅನಂತ ಪದ್ಮನಾಭ ಸ್ವಾಮಿ - ಬಾಳೆಹಣ್ಣುಗಳಿಗೆ ವಿಶೇಷ ಪ್ರೀತಿ<br/>
              • ಇಚ್ಛಾಪೂರ್ತಿ ದೇವರು - ಭಕ್ತರ ಮನಸ್ಕಾಮನೆಗಳನ್ನು ಈಡೇರಿಸುವ ಶಕ್ತಿ<br/>
              • ಶಾಂತಿ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಅನುಭವ ಪ್ರದಾನ<br/>
              • ಐತಿಹಾಸಿಕ ಮಹತ್ವ ಮತ್ತು ಪ್ರಾಚೀನತೆ
            </div>
            <p className="text-en">
              ಶತಮಾನಗಳಿಂದ ಭಕ್ತರು ಈ ಪವಿತ್ರ ಕ್ಷೇತ್ರಕ್ಕೆ ಬಂದು ತಮ್ಮ ಮನಸ್ಕಾಮನೆಗಳನ್ನು ಈಡೇರಿಸಿಕೊಂಡಿದ್ದಾರೆ. ವಿಶೇಷವಾಗಿ ಬಾಳೆಹಣ್ಣು ಸೇವೆ, ಬೆಳ್ಳಿಯ ಅಂಗಾಂಗ ಮಾದರಿಗಳ ಅರ್ಪಣೆ ಮತ್ತು ರಥೋತ್ಸವದ ಸಂದರ್ಭದಲ್ಲಿ ಭಕ್ತರು ಅದ್ಭುತ ಅನುಭವಗಳನ್ನು ಹೊಂದಿದ್ದಾರೆ.
            </p>
          </section>

          <section className="section">
            <h2 className="section-title">🕊️ ಸಮಾಪನ - Conclusion</h2>
            <p className="text-kan">
              ಪೆರ್ಡೂರು ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭ ಸ್ವಾಮಿ ದೇವಾಲಯವು ಕೇವಲ ಒಂದು ಪೂಜಾ ಸ್ಥಳವಲ್ಲ, ಇದು ವೈಷ್ಣವ-ಶೈವ ಸಂಸ್ಕೃತಿಯ ಸಂಯೋಜನೆಯುಳ್ಳ ಪವಿತ್ರ ಕ್ಷೇತ್ರವಾಗಿದೆ. ಶ್ರದ್ಧೆ, ಇತಿಹಾಸ, ಆಚರಣೆಗಳು ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಅನುಭವಗಳಿಂದ ಕೂಡಿದ ಈ ದೇವಾಲಯವು ಭಕ್ತರ ಹೃದಯದಲ್ಲಿ ಅಮಿತ ಸ್ಥಾನವನ್ನು ಪಡೆದಿದೆ.
            </p>
            <p className="text-en">
              Whether you come for the famous Banana Seva, to witness the grand Rathotsava celebrations, or simply to experience the divine peace of this ancient temple, Perdoor Sri Ananthapadmanabha Temple offers a unique spiritual journey that connects devotees to centuries of tradition and faith.
            </p>
            <div className="highlight-box">
              <strong>🙏 ಓಂ ಶ್ರೀ ಅನಂತಪದ್ಮನಾಭಾಯ ನಮಃ 🙏</strong><br/>
              <em>ಭಕ್ತರ ಮನಸ್ಕಾಮನೆಗಳನ್ನು ಈಡೇರಿಸುವ ಕೃಪಾಮಯ ದೇವರಿಗೆ ನಮಸ್ಕಾರ</em>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PerdoorTempleHistory;
